import type { Translations } from '../types';

export const ar: Translations = {
  common: {
    home: 'الرئيسية',
    about: 'من نحن',
    contact: 'اتصل بنا',
    cart: 'سلة التسوق',
    wishlist: 'المفضلة',
    profile: 'حسابي',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    search: 'بحث',
    menu: 'القائمة',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    remove: 'إزالة',
    viewAll: 'عرض الكل',
    readMore: 'اقرأ المزيد',
    learnMore: 'معرفة المزيد',
    giftCard: 'بطاقة هدية',
    customerService: 'خدمة العملاء',
    faq: 'الأسئلة الشائعة',
    sizeGuide: 'دليل المقاسات',
    tradeIn: 'Alice Trade In',
    trackOrder: 'تتبع الطلب',
    categories: 'الفئات',
  },
  product: {
    addToCart: 'أضف إلى السلة',
    addedToCart: 'تمت الإضافة إلى السلة',
    outOfStock: 'نفذ من المخزون',
    inStock: 'متوفر',
    price: 'السعر',
    quantity: 'الكمية',
    size: 'المقاس',
    color: 'اللون',
    description: 'الوصف',
    details: 'التفاصيل',
    reviews: 'التقييمات',
    relatedProducts: 'منتجات ذات صلة',
    noProductsFound: 'لم يتم العثور على منتجات',
    selectOption: 'اختر خيار',
    selectSize: 'اختر المقاس',
    selectColor: 'اختر اللون',
  },
  cart: {
    title: 'سلة التسوق',
    empty: 'سلة التسوق فارغة',
    itemsInCart: 'عناصر في السلة',
    subtotal: 'المجموع الفرعي',
    total: 'المجموع',
    checkout: 'الدفع',
    continueShopping: 'متابعة التسوق',
    removeItem: 'إزالة العنصر',
    updateQuantity: 'تحديث الكمية',
    proceedToCheckout: 'المتابعة للدفع',
  },
  auth: {
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    signOut: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    createAccount: 'إنشاء حساب',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    dontHaveAccount: 'ليس لديك حساب؟',
    welcomeBack: 'مرحبًا بعودتك',
    personalArea: 'حسابي',
  },
  footer: {
    about: 'من نحن',
    shipping: 'الشحن',
    returns: 'الإرجاع',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الاستخدام',
    accessibility: 'إمكانية الوصول',
    cookies: 'إعدادات ملفات تعريف الارتباط',
    contactUs: 'اتصل بنا',
    followUs: 'تابعنا',
    newsletter: 'اشترك في النشرة الإخبارية',
    newsletterPlaceholder: 'أدخل بريدك الإلكتروني',
    subscribe: 'اشترك',
    subscribed: 'تم الاشتراك بنجاح!',
    importantLinks: 'روابط مهمة',
    copyright: '© جميع الحقوق محفوظة',
  },
  newsletter: {
    title: 'ابق على اطلاع',
    subtitle: 'اشترك في نشرتنا الإخبارية للحصول على آخر العروض والخصومات',
    placeholder: 'البريد الإلكتروني',
    button: 'اشترك',
    success: 'تم الاشتراك في النشرة الإخبارية بنجاح!',
    error: 'حدث خطأ، يرجى المحاولة مرة أخرى',
    consent: 'أوافق على تلقي التحديثات والعروض',
  },
  cookies: {
    bannerTitle: 'نحن نستخدم ملفات تعريف الارتباط',
    bannerText: 'يستخدم هذا الموقع ملفات تعريف الارتباط لتحسين تجربة التصفح الخاصة بك.',
    accept: 'قبول الكل',
    reject: 'رفض الكل',
    customize: 'تخصيص',
    preferencesTitle: 'تفضيلات ملفات تعريف الارتباط',
    necessary: 'ملفات تعريف الارتباط الضرورية',
    necessaryDesc: 'هذه الملفات ضرورية لعمل الموقع ولا يمكن تعطيلها.',
    analytics: 'ملفات تعريف الارتباط التحليلية',
    analyticsDesc: 'تساعدنا في فهم كيفية استخدام الزوار للموقع.',
    marketing: 'ملفات تعريف الارتباط التسويقية',
    marketingDesc: 'تُستخدم لعرض إعلانات ذات صلة بك.',
    savePreferences: 'حفظ التفضيلات',
  },
  errors: {
    generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    notFound: 'الصفحة غير موجودة',
    unauthorized: 'ليس لديك صلاحية لعرض هذا المحتوى',
    networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك بالإنترنت.',
    tryAgain: 'حاول مرة أخرى',
  },
  seo: {
    defaultTitle: 'Alice Jewellery - مجوهرات وساعات',
    defaultDescription: 'أفضل متجر للمجوهرات والساعات في إسرائيل. مجموعة واسعة من المجوهرات الذهبية والألماس والساعات.',
  },
};
